import React from 'react';
import HeaderMenu from '../HeaderMenu/HeaderMenu';
import FooterMenu from '../FooterMenu/FooterMenu';

import styles from './Layout.module.css';

export default function Layout({ children, user }) {
    return (
        <div className={styles.layout}>
            <HeaderMenu user={user} />
            {children}
            <FooterMenu />
        </div>
    );
}
